export * from "@web-monorepo/shared/utils/env";
export { default } from "@web-monorepo/shared/utils/env";
import { isTesting, isProduction, isDevelopment } from "@web-monorepo/shared/utils/env";

export const isProd = isProduction;
export const isDev = isDevelopment;

if (!isTesting && !isDev && !isProd) {
  throw new Error("Please set NODE_ENV to either 'test', 'development' or 'production'");
}
